import React from "react";
import "./banner.css";

class Banner extends React.Component{
  render(){
    return(
        <div className="bannerBack">
          <div className="banner">
            
          </div>
        </div>
    )
  }
}

export default Banner;